export default "__VITE_ASSET__CqZEspum__"